import { DataCaptureEditFormResponse } from 'types/dataCaptureTypes';

export type TransformedField = {
  form_field_id: number;
  field_name: string;
  field_value?: string | boolean;
  help_text: string;
  field_type: string;
  is_required: boolean;
  original_field_name?: string;
  original_help_text?: string;
  is_custom?: boolean;
  field_key?: string;
  is_visible?: boolean;
};

export type TransformedSection = {
  section_id: number;
  section_name: string;
  section_help_text: string;
  fields: TransformedField[];
};

export type TransformedData = {
  formName: string;
  formDescription: string;
  sections: TransformedSection[];
};

export const transformSectionsAndFields = (
  data: DataCaptureEditFormResponse
): TransformedData => {
  const transformedSections: TransformedSection[] = data.sections.map(
    section => ({
      section_id: section.section_id,
      section_name: section.name,
      section_help_text: section.help_text,
      fields: section.process_form_field.map(field => ({
        form_field_id: field.form_field_id,
        field_name: field.name,
        help_text: field.help_text,
        field_type: field.metadata.field_type,
        is_required: field.metadata.is_required,
        is_visible: field.metadata.is_visible,
        original_field_name: field.metadata.field_name,
        original_help_text: field.metadata.help_text,
        is_custom: !!field.custom_field_id,
        field_key: field.metadata.field_key,
      })),
    })
  );

  return {
    formName: data.formName,
    formDescription: data.formDescription,
    sections: transformedSections,
  };
};
